module.exports = __webpack_public_path__ + "static/img/property_1_qiwi.af491b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_qiwi.png
// module id = 0dWU
// module chunks = 1